let lastScroll = 0;
const initFixedMenu = () => {
    const body = document.body;
    const navbar = document.querySelector('.navbar.fixed-top');
    const mainContent = document.querySelector('#main, #primary');
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";

    if (!navbar || !mainContent) {
        return;
    }

    const updateMainOffset = () => {
        const navbarHeight = navbar.offsetHeight;
        mainContent.style.paddingTop = `${navbarHeight}px`;
        document.documentElement.style.setProperty("--fixed-navbar-offset", `${navbarHeight}px`);
    };

    const scrollHandler = () => {
        const viewportOffset = mainContent.getBoundingClientRect();
        const top = viewportOffset.top;
        const currentScroll = window.scrollY;

        if (currentScroll <= 0) {
            body.classList.remove(scrollUp);
            body.classList.remove(scrollDown);
            return;
        }

        if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && (top < 50)) {
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
        }

        lastScroll = currentScroll;
    };

    updateMainOffset();
    window.addEventListener("scroll", scrollHandler);
    window.addEventListener("resize", updateMainOffset);
    window.addEventListener("load", updateMainOffset);

    if (window.ResizeObserver) {
        const navbarResizeObserver = new ResizeObserver(() => {
            updateMainOffset();
        });

        navbarResizeObserver.observe(navbar);
    }

    scrollHandler();
};
export default initFixedMenu;
